import { DashboardChip } from './DashboardChip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';

interface UnresolvedIssueChipProps {
    label?: React.ReactNode;
    onClick?: () => void;
    isDeactivated?: boolean;
}

export const UnresolvedIssueChip = ({ label, onClick, isDeactivated }: UnresolvedIssueChipProps) => {
    return (
        <DashboardChip
            text={label ?? <InfoOutlinedIcon fontSize='small' />}
            icon={label ? <InfoOutlinedIcon /> : <></>}
            backgroundColor="#C10000"
            borderColor="#920000"
            onClick={onClick}
            isDeactivated={isDeactivated}
        />
    );
};
